export const modulesArrayForPermissions = [
  {
    name: "Dashboard",
    permissions: ["Read"]
  },
  {
    name: "Meetings"
  },
  {
    name: "Mail"
  },
  {
    name: "Employees"
  },
  {
    name: "Attendance"
  },
  // Change working times older than yesterday (own or, with Employees, colleagues')
  {
    name: "Attendance-corrections",
    permissions: ["Update"]
  },
  {
    name: "Leaves"
  },
  {
    name: "Designations"
  },
  {
    name: "Departments"
  },
  {
    name: "Contracts"
  },
  {
    name: "Shifts-planning"
  },
  {
    name: "Shifts"
  },
  {
    name: "Clients"
  },
  {
    name: "Pipelines"
  },
  {
    name: "Calendar"
  },
  // Disposition board: Read = board and week plans, Create = plan jobs, Update = move/reassign,
  // vehicles, skills, email plans, Delete = remove jobs. "My day" needs no permission.
  {
    name: "Dispatch"
  },
  // Review requests: Read = list, Create = send one by hand (settings stay with the owner)
  {
    name: "Reviews",
    permissions: ["Create", "Read"]
  },
  {
    name: "Deals"
  },
  {
    name: "Inventory"
  },
  {
    name: "Invoices"
  },
  {
    name: "Vendor-contracts"
  },
  {
    name: "Accounting"
  },
  {
    name: "Projects"
  },
  {
    name: "Tasks"
  },
  {
    name: "Measurements"
  },
  // Regieberichte; creating an invoice from them also needs "Invoices" Create
  {
    name: "Work-reports"
  },
  // Nachunternehmer with their compliance documents and orders
  {
    name: "Subcontractors"
  },
  // Material & article catalog, DATANORM imports, offer calculation, IDS baskets
  {
    name: "Materials"
  },
  // Nachträge (change orders to awarded offers)
  {
    name: "Change-orders"
  },
  // Kundenportal: Read = see a customer's portal status and answers, Update = invite, switch
  // off, share files
  {
    name: "Customer-portal"
  },
  // Wartungsverträge, Anlagen and Prüfprotokolle; invoices and defect offers also need "Invoices" Create
  {
    name: "Maintenance"
  },
  // Site documentation: Create = document and edit own entries, Read = see everyone's
  {
    name: "Site-docs"
  },
  // Arbeitsschutz: Unterweisungen, qualifications and checks, risk assessments
  {
    name: "Safety"
  },
  // Apprentice records and reviewing/signing Berichtsheft weeks (Update). Apprentices and the
  // trainer named on a record need no permission for their own records.
  {
    name: "Apprenticeship"
  },
  // Fördermittel (BEG / KfW / § 35c); importing costs also needs "Invoices" Read, adding the
  // clause to an offer "Invoices" Update
  {
    name: "Funding"
  },
  // Bautagebuch: Create = write daily entries, Read = all entries and PDFs, Update = sign,
  // correct locked days, Behinderungs-/Bedenkenanzeigen, send to the client
  {
    name: "Site-diary"
  },
  // Abnahmen, Gewährleistung, Bürgschaften; replacing a retention also needs "Invoices" Update
  {
    name: "Warranty"
  },
  {
    name: "Boards"
  },
  {
    name: "Room-management"
  },
  {
    name: "Assests-controls"
  },
  {
    name: "Directory"
  },
  {
    name: "Ai"
  },
  {
    name: "Predefinedvalues"
  },
  {
    name: "Roles"
  },
  // Not Found İn Employess Dashboard
  {
    name: "Chats"
  },
  {
    name: "Directory"
  },
  {
    name: "Milestones"
  },
  {
    name: "Salary-Slips"
  }
];
